export default {
  items: [
  {
    name: 'Dashboard',
    url: '/',
    icon: 'fa fa-dashboard',
    // badge: {
    //   variant: 'primary',
    //   text: 'NEW'
    // }
  },
  {
    name: 'Marketing Event',
    url: '/marketing-event',
    icon: 'fa fa-calendar',
    children: 
      [
        {
          name: 'Event List',
          url: '/agent/marketing-event',
          icon: 'fa fa-calendar'
        },
      ]
    }  
  ]
}
